import FamilyInformation from "./FamilyInformation";

export default FamilyInformation;